
import React from 'react'
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import usePtp from 'src/hooks/usePtp';
import ModalPtpPreguntas from 'src/pages/NewFinCompra/ModalPtpPreguntas';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { guardarLead } from 'src/services';
import { Layout } from 'src/pages/PaginaPago/styleds';
import { useHistory } from 'react-router-dom';

let err = ""

const PlaceToPay = () => {
  const { idCotizacion, cotizacion } = useCotizacion();
  const history = useHistory();

  const { setLoading, resetLoading, valdiarTerminos } = usePaginaPago();
  const { getCambiarSuscripcion } = usePtp();

  const { addWarningToast } = useCustomToast();


  const pagarPtp = async () => {
    setLoading({
      loading: true,
      principal: 'Procesando',
      secundario: 'Pronto seras redireccionado a Place to Pay',
    });

    guardarLead(idCotizacion, `PAGINA_PAGO__SELECCIONO_P2P`);

    const res = await getCambiarSuscripcion();
    const { hasError, url } = res

    err = res.hasError;

    if (hasError) {
      resetLoading();
      addWarningToast(typeof hasError == "string" ? hasError : 'HA OCURRIDO UN PROBLEMA AL REDIRECCIONAR A PLACE TO PAY');
    } else
      window.location.href = url;
  };

  console.log("cotizacion?.historialPago?.length", cotizacion?.historialPago?.length, cotizacion?.historialPago)

  return (
    <div className="row justify-content-center flex-column  py-4">
      <Layout>
        <img
          onClick={valdiarTerminos(pagarPtp)}
          className="logo"
          style={{ width: 180 }}
          src="https://static.placetopay.com/placetopay-logo.svg"
          alt="PLACE TO PAY"
        />
      </Layout>
      {cotizacion?.historialPago?.length > 0 &&

        <BtnPrincipal label="Mis pagos" onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)} />
      }

      <ModalPtpPreguntas />
    </div>
  );
};

export default PlaceToPay;
